export default __webpack_public_path__ + "static/media/appcardimg.eed21513.png";